import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {Dictionary} from '../model/dictionary';
import {Constants} from './constants';
import {IsQueryResponse} from '../components/register/is-query-response';
import {BackendServiceResponse} from '../model/backend-service-response';
import {Report} from '../model/report';
import {User} from '../model/user';
import {SharedReports} from '../model/shared-reports';
import {MasbitHttpService} from './http/masbit-http.service';
import {NotificationsDictionary} from "../model/notifications-dictionary";
import {ServiceResponse} from "../components/register/service-response";
import { SearchItem } from '../model/search-item';
import {Group} from "../model/group";
import {Set} from "../model/set"

@Injectable()
export class CommonService {

  constructor(private httpClient: MasbitHttpService) { }

  paramsEnable = new HttpParams().set('enable', 'true');
  paramsEnableOrderByDictId = new HttpParams().set('enable', 'true').set('sort', 'dictId');

  getContentTypeDictionary() : Observable<Array<Dictionary>> {
    return this.httpClient.get<Array<Dictionary>>(Constants.DICT_CONTENT_TYPE_URL, this.paramsEnable);
  }
  getProductsDictionary() : Observable<Array<Dictionary>> {
    return this.httpClient.get<Array<Dictionary>>(Constants.DICT_PRODUCTS_URL, this.paramsEnable);
  }
  getInstitutionDictionary() : Observable<Array<Dictionary>> {
    return this.httpClient.get<Array<Dictionary>>(Constants.DICT_INSTITUTION_URL, this.paramsEnable);
  }
  getClientGroupsDictionary() : Observable<Array<Dictionary>> {
    return this.httpClient.get<Array<Dictionary>>(Constants.DICT_CLIENT_GROUPS_URL, this.paramsEnable);
  }
  getAreaDictionary() : Observable<Array<Dictionary>> {
    return this.httpClient.get<Array<Dictionary>>(Constants.DICT_INTEREST_AREA_URL, this.paramsEnable);
  }
  getNotificationFrequencyDictionary() : Observable<Array<NotificationsDictionary>> {
    return this.httpClient.get<Array<NotificationsDictionary>>(Constants.DICT_NOTIFICATIONS_FREQUENCY_URL, this.paramsEnable);
  }
  getFrequencyDictionary() : Observable<Array<Dictionary>> {
    return this.httpClient.get<Array<Dictionary>>(Constants.DICT_PUBLICATION_FREQUENCY_URL, this.paramsEnableOrderByDictId);
  }
  getPositionDictionary() : Observable<Array<Dictionary>> {
    return this.httpClient.get<Array<Dictionary>>(Constants.DICT_POSITIONS_URL, this.paramsEnable);
  }
  userExists(email : string): Observable<IsQueryResponse> {
    return this.httpClient.post<IsQueryResponse>(Constants.USER_EXISTS_SERVICE_URL, {email : email});
  }
  setExists(name : string, setId? : string) : Observable<IsQueryResponse> {
    if (setId)
      return this.httpClient.get<IsQueryResponse>(Constants.SET_EXISTS_SERVICE_URL.concat(name,'/',setId));
    else
      return this.httpClient.get<IsQueryResponse>(Constants.SET_EXISTS_SERVICE_URL.concat(name));
  }

  downloadReportFile(id : number) : Observable<any> {
    return this.httpClient.getFile(Constants.REPORT_GET_REPORT_FILE_SERVICE_URL.concat(id.toString()), /*{responseType : 'blob'}*/);
  }

  downloadDemoFile(id : number) : Observable<any>{
    return this.httpClient.getFile(Constants.REPORT_GET_DEMO_FILE_SERVICE_URL.concat(id.toString()), /*{responseType : 'blob'}*/)
  }

  getSuggestedReports(sortString? : string) : Observable<BackendServiceResponse<number, Array<Report>>> {
    let params : any;
    params = {};
    if (sortString && sortString.length > 0)
      params.sortString = sortString;

    return this.httpClient.post<BackendServiceResponse<number, Array<Report>>>(
      Constants.USER_GET_SUGGESTED_REPORTS_SERVICE_URL, params);
  }
  getUserReports(filterParams : any) : Observable<BackendServiceResponse<number, Array<Report>>> {
    return this.httpClient.post<BackendServiceResponse<number, Array<Report>>>(Constants.REPORT_LIST_FOR_USER_SERVICE_URL, filterParams);
  }

  getSuggestions() : Observable<BackendServiceResponse<number, Array<SearchItem>>> {
    return this.httpClient.post<BackendServiceResponse<number, Array<SearchItem>>>(Constants.REPORT_GET_SUGGESTIONS_SERVICE_URL, '');
  }
  prefilterUserReports(filterParams : any) : Observable<BackendServiceResponse<number, number>> {
    return this.httpClient.post<BackendServiceResponse<number, number>>(Constants.PREFILTER_REPORTS_FOR_USER_SERVICE_URL, filterParams);
  }
  addToFavourites(reportId : number, userId : number) : Observable<BackendServiceResponse<number, string>> {
    return this.httpClient.post<BackendServiceResponse<number, string>>(Constants.REPORT_ADD_TO_FAVOURITES_SERVICE_URL,
      {userId : userId, reportId : reportId})
  }
  sendShareReportMessage(email: string, reportId : string) : Observable<BackendServiceResponse<number, string>> {
    let params = {email: email, reportId : reportId};
    return this.httpClient.post<BackendServiceResponse<number, string>>(Constants.REPORT_SEND_SHARE_LINK_SERVICE_URL , params);
  }
  sendAccessRequestUrl(userId : number, reportId : number, message: string, sendCopy : boolean) : Observable<BackendServiceResponse<number, string>> {
    let params = {userId: userId, reportId : reportId, message : message, sendCopy : sendCopy};
    return this.httpClient.post<BackendServiceResponse<number, string>>(Constants.REPORT_SEND_ACCESS_REQUEST_URL, params);
  }
  sendEnquiry(email: string, firstName : string, lastName: string, message : string, subject : string, sendCopy : boolean) : Observable<BackendServiceResponse<number, string>> {
    let params = {email: email, firstName : firstName, lastName : lastName, message : message, subject : subject, sendCopy : sendCopy};
    return this.httpClient.post<BackendServiceResponse<number, string>>(Constants.USER_SEND_ENQUIRY_URL, params);
  }
  getUser(id : string) : Observable<BackendServiceResponse<number, User>> {
    return this.httpClient.get<BackendServiceResponse<number, User>>(Constants.GET_USER_URL.concat(id));
  }
  getSafeDomainLogo(email: string) : Observable<Blob> {
    let domain: string;
    let emailSplitted = email.split('@');
    if (emailSplitted.length==2)
      domain=emailSplitted[1];

    return this.httpClient.getFile(Constants.GET_SAFEDOMAIN_LOGO_URL.concat(domain), /*{responseType: 'blob' }*/);
  }
  shareReport(reportId : number, reportSharedByUserId : number, emailToShareTo : string, message : string)
    : Observable<BackendServiceResponse<number, SharedReports>> {

    let options = {
      reportId : reportId,
      userId : reportSharedByUserId,
      email : emailToShareTo,
      message : message,
    };

    return this.httpClient.post<BackendServiceResponse<number, SharedReports>>(Constants.REPORT_SHARE_URL, options);
  }

  getSharedReport(id: string): Observable<BackendServiceResponse<number, SharedReports>> {
    return this.httpClient.get<BackendServiceResponse<number, SharedReports>>(Constants.GET_SHARED_REPORT_BY_ID.concat(id));
  }

  sendActivationEmail(email : string) : Observable<ServiceResponse> {
    return this.httpClient.post<ServiceResponse>(Constants.SEND_ACTIVATION_EMAIL_SERVICE_URL, {email : email});
  }

  registerClickOnElement(eventName : string, position : string, object : string, id: number) : Observable<ServiceResponse> {
    return this.httpClient.post<ServiceResponse>(Constants.REGISTSTER_CLICK_ON_ELEMENT_URL + 'no_loader', {
      eventname : eventName,
      position : position,
      object : object,
      id : id
    });
  }

  getInstruction() : Observable<any> {
    return this.httpClient.getFile(Constants.GET_INSTRUCTION_URL);
  }

  hasAccessToContentType(contentTypeDictId : number) : Observable<ServiceResponse> {
    return this.httpClient.get<ServiceResponse>(Constants.USER_HAS_ACCESS_CONTENTTYPE_URL.concat(contentTypeDictId.toString()))
  }

  getGroupList(sortString : string) : Observable<BackendServiceResponse<string, Array<Group>>> {
    return this.httpClient.post<BackendServiceResponse<string, Array<Group>>>(Constants.GET_GROUPS_URL , {'sortString' : sortString});
  }
  
  getSetList(sortString : string) : Observable<BackendServiceResponse<number, Array<Set>>> {
    return this.httpClient.post<BackendServiceResponse<number, Array<Set>>>(Constants.GET_SETS_URL, {'sortString' : sortString});
  }
}
